// removed by extract-text-webpack-plugin
module.exports = {"urinalysisResults":"_2tynFG84S3NJcjjNGUghjV"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/patientPages/testing/Urinalysis.scss
// module id = 437
// module chunks = 0